import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-no-empresa-selected',
  standalone: true,
  imports: [MatIconModule],
  template: `
    <div class="flex min-h-[52vh] items-center justify-center px-4 py-8 sm:px-6">
      <section
        class="w-full max-w-2xl overflow-hidden rounded-2xl border border-emerald-200/70 bg-gradient-to-br from-emerald-50 via-white to-teal-50 shadow-[0_12px_32px_-18px_rgba(16,185,129,0.45)] dark:border-emerald-500/30 dark:from-dark-bg-tertiary dark:via-dark-card dark:to-dark-bg-secondary"
      >
        <div class="h-1.5 w-full bg-gradient-to-r from-emerald-400 via-teal-400 to-cyan-400"></div>

        <div class="flex flex-col items-center gap-4 p-6 text-center sm:gap-5 sm:p-8">
          <div class="relative">
            <span class="absolute inset-0 rounded-full bg-emerald-300/30 blur-xl dark:bg-emerald-400/20"></span>
            <div
              class="relative flex h-16 w-16 items-center justify-center rounded-2xl border border-emerald-200 bg-white/80 dark:border-emerald-500/30 dark:bg-dark-bg-tertiary"
            >
              <mat-icon class="!h-9 !w-9 !text-[36px] leading-none text-emerald-500 dark:text-emerald-400">
                {{ icon() }}
              </mat-icon>
            </div>
          </div>

          <div class="space-y-2">
             <span
            class="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white/80 px-3 py-1 text-[11px] font-medium tracking-[0.02em] text-slate-600 dark:border-dark-border dark:bg-dark-bg-tertiary dark:text-dark-text-secondary"
          >
            <mat-icon class="!h-4 !w-4 !text-[16px] leading-none text-emerald-500 dark:text-emerald-400"> info </mat-icon>
            {{ hint() }}
          </span>
            <!-- <h3 class="m-0 text-base font-semibold tracking-[0.01em] text-slate-900 sm:text-lg dark:text-dark-text">
              {{ title() }}
            </h3> -->
            <p class="m-0 max-w-xl text-sm leading-6 text-slate-600 dark:text-dark-text-secondary">
              {{ description() }}
            </p>
          </div>
        </div>
      </section>
    </div>
  `,
})
export class NoEmpresaSelectedComponent {
  readonly icon = input<string>('business');
   readonly hint = input<string>('Selecciona una empresa para continuar');
  /*readonly title = input<string>('Primero debes seleccionar una empresa');*/
  readonly description = input<string>(
    'Selecciona una empresa desde el selector para cargar la información de los módulos y habilitar acciones.'
  );
}
